import { FilterInput } from '../components/RowFilters/index';

export const getColumnsFromData = (data) => {
  const NamesArr = getColumnNamesFromData(data);
  return createColumns(NamesArr);
};

export const getColumnNamesFromData = (data) => Object.keys(data[0]);

export const createColumns = (columnNameArr) => columnNameArr.map((name) => ({
  Header: name,
  accessor: name,
  Filter: FilterInput,
  width: 150,
  minWidth: 150,
  maxWidth: 150,
}));

export const prependColumn = (columnArr, name) => {
  columnArr.unshift({
    Header: name,
    accessor: name,
    Filter: FilterInput,
    width: 150,
    minWidth: 150,
    maxWidth: 150,
  });
};
